<template>
    <div id="report-totals-chart">
        <div class="loading" v-if="!loaded">Loading...</div>
        <div class="empty-dashboard" v-else-if="!dataAvailable">No data available</div>
        <canvas @click="chartClicked" ref="canvas"></canvas>
    </div>
</template>

<style lang="scss">
    @import '../../sass/_global_variables.scss';

    #report-totals-chart {
        padding: 5px;
        height: 320px;
        overflow-y: hidden;

        > * {
            width: 100% !important;
            height: 100% !important;
        }

        > .loading {
            color: $dark-blue;
            font-size: 150%;
            text-align: center;
        }
    }
</style>

<script>
    import Chart from 'chart.js'

    export default {
        props: {
            type: { default: 'weekly' }
        },

        data: function() {
            return {
                loaded: false,
                data: [],
                canvas: $(),
                chart: null,
                zoomed: false,
                dates: { }
            }
        },

        computed: {
            dataAvailable() {
                var total = 0;
                this.data.map(item => { return parseInt(item.total) }).forEach(item => { total += item });
                if (total == 0) return false;
                return true;
            }
        },

        methods: {
            createChart (params) {
                if (this.chart) {
                    this.chart.destroy();
                }

                this.$http.get('/overview/report-totals', { params: params }).then(function(response) {
                    if (response.data) {
                        if (response.data.summary) {
                            this.$emit('update_reports_summary', response.data.summary);
                        }
                        this.loaded = true;
                        if (response.data.totals && response.data.totals.length) {
                            this.data = response.data.totals;
                            this.drawChart({
                                title: (params && params.month) ? params.month : null
                            });
                        }
                        else {
                            this.data = [];
                        }
                    }
                });
            },

            drawChart (options) {
                this.canvas = $(this.$refs.canvas);
                if (this.canvas.length == 0) return;

                this.chart = new Chart(this.canvas, {
                    type: 'bar',
                    data: {
                        labels: this.data.map(function (r) {
                            return r.label
                        }),
                        datasets: [
                            {
                                label: 'Weekly Total',
                                backgroundColor: 'rgba(38,162,217,0.6)',
                                borderColor: 'rgba(38,162,217,1)',
                                data: this.data.map(function (r) {
                                    return r.total
                                })
                            }
                        ]
                    },
                    options: {
                        responsive: true,
                        maintainAspectRatio: false,
                        title: {
                            display: (options.title) ? true : false,
                            text: (options.title) ? options.title : null
                        },
                        legend: {display: false},
                        scales: {
                            xAxes: [{
                                //display: false,
                                ticks: {
                                    //autoSkip: true,
                                    //maxTicksLimit: 15
                                }
                            }]
                        },
                        tooltips: {
                            callbacks: {
                                label: function (tooltipItems) {
                                    return 'Total Reports: ' + tooltipItems.yLabel;
                                }
                            }
                        }
                    }
                });
            },

            chartClicked (event) {
                var points = this.chart.getElementsAtEvent(event);
                var point = points[0];
                if (points.length) {
                    var date = this.chart.data.labels[point._index];
                    var total = this.chart.data.datasets[0].data[point._index];
                    if (this.zoomed) {
                        this.dates = { start: date, end: date };
                        this.viewReports();
                    }
                    else {
                        var month = this.chart.data.labels[point._index];
                        if (total < 50) {
                            this.dates = { month: date };
                            this.viewReports();
                        }
                        else {
                            this.zoomed = true;
                            this.loaded = false;
                            this.createChart({month: month});
                        }
                    }
                }
            },

            viewReports () {
                var params = (this.dates.month)
                        ? 'month=' + this.dates.month
                        : 'start=' + this.dates.start + '&end=' + this.dates.end;
                document.location.href = '/documents/reports?' + params;
            }
        },

        mounted: function() {
            this.createChart();
        }
    }
</script>



// WEBPACK FOOTER //
// report-totals-chart.vue?105b5ac1